<mat-card class="information-linux-card" >
  <mat-card-header>
    <div mat-card-avatar class="modbus-header-image"><mat-icon aria-hidden="false" aria-label="home icon">pets</mat-icon></div>
    <mat-card-title>Linux System information  </mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <mat-list>

      <mat-list-item >
        <mat-icon mat-list-icon>history</mat-icon>

        <div mat-line>Uptime: {{ information.uptime }} minutes </div>
      </mat-list-item>


      <mat-list-item >
        <mat-icon mat-list-icon>storage</mat-icon>
        <div mat-line>mem_total: {{ information.mem_total }}</div>
        <div mat-line>mem_free: {{ information.mem_free }}</div>
      </mat-list-item>



      <mat-list-item >
        <mat-icon mat-list-icon>folder</mat-icon>
        <div mat-line>TMS Driver:  {{ information.linux_driver }}</div>
        <div mat-line>Command:  {{ information.tms_driver }}</div>
        <div mat-line>Watchdog:  {{ information.tms_watchdog }}</div>
      </mat-list-item>


    </mat-list>



  </mat-card-content>
</mat-card>
